import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EMAIL_SALES } from '@app/config';
import { FaqAccordionComponent, SectionHeaderComponent } from '@app/widgets';
import { PARTNERS_FAQS } from '../../constants';

@Component({
  selector: 'app-partners-faq-section',
  imports: [SectionHeaderComponent, FaqAccordionComponent],
  templateUrl: './partners-faq-section.component.html',
  styleUrl: './partners-faq-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersFaqSectionComponent {
  protected readonly emailSales = EMAIL_SALES;
  protected readonly items = PARTNERS_FAQS;
}
